export default __webpack_public_path__ + "static/media/screen2.9d2871b9.png";